import { jsx as _jsx } from "react/jsx-runtime";
import { FileUploadListItem } from './FileUploadListItem';
export const FileUploadList = props => {
    const handleDelete = (index) => {
        if (props.onDelete)
            props.onDelete(index);
    };
    return props.files && props.files.length > 0 ? (_jsx("ul", Object.assign({ className: "list-group" }, { children: props.files.map((file, index) => (_jsx(FileUploadListItem, { disabled: props.disabled, file: file.file, state: file.state, onDelete: () => handleDelete(index) }, index))) }))) : null;
};
